<template>
	<div
	class="car-item text-center"
	:class="{'car-item--active': resCar.groupKey && resCar.groupKey ==  carGroup.groupKey}"
	>
		<!-- <img
		:width="width"
		:src="(carGroup.download ? 'data:image/jpeg;base64,' + carGroup.download : '/static/img/car-dummy.png')" /> -->

		<div class="car-image d-flex align-items-center">
			
			<img :width="width"	:src="(carGroup.download ?  carGroup.download : '/static/img/car-dummy.png')" />
		</div>

<!-- 		<div class="car-details">
			<router-link :to="{name: 'PageDetails'}">
				<button type="button" class="btn btn-outline-info btn-wp">
					{{ $t('Details') }}
				</button>
			</router-link>
		</div> -->

		<p class="car-class">{{ carGroup.category}}</p>
		<h4 class="car-typ">{{ carGroup.app_description || carGroup.title_web }}</h4>
		<div v-if="price > 0">
			<p  class="car-price">{{ formatter.OUTPUT_PRICE(price) }} €</p>
			<small v-if="groupDetails.additionalKilometerPriceVat" class="car-additional"> {{ $t('Zusatz-KM') }}: {{ formatter.ROUND_PRICE(groupDetails.additionalKilometerPriceVat) }} € </small>
			<small v-else class="car-additional car-additional--error">Im gewählten Zeitraum nicht verfügbar</small> 
			<div class="car-extras">
				<div class="car-extra" v-for="extras in carGroup.extras"  v-html="iconTranslator(extras.extra.name,extras.value)">
				</div>
			</div>



			<button v-if="groupAvaible" @click.prevent="$emit('click', carGroup)" type="button" class="btn btn-secondary btn-wp">
				{{ $t('Select') }}
			</button>
			<button v-else type="button" class="btn btn-wp btn-secondary btn-secondary--disabled">
				{{ $t('not available') }}
			</button>
		</div>

		<div v-else>


		<p  class="car-price">&nbsp;</p>
			<small  class="car-additional">&nbsp;</small>
		<div class="car-extras invisible">
				<div class="car-extra" v-for="extras in carGroup.extras"  v-html="iconTranslator(extras.extra.name,extras.value)">
				</div>
		</div>
		<button type="button" class="btn btn-wp btn-secondary btn-secondary--disabled">
				{{ $t('not available') }}
		</button>
	</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import formatter from '@/store/orm/helpers/formater';

export default {
	name: "CarGroupCard",

	computed: {
	    ...mapGetters('orm/reservation', {
			resCar: 'car',
	    }),
	},
	data() {
		return {
			formatter,
			thisGroup: this.$store.getters['orm/group'](this.carGroup.groupKey),
		};
	},

	props: {
		width: {
			type: Number,
			default: 320
		},
		price: {
			type: Number,
			default: 0
		},
		carGroup: {
			type: Object,
			default() {
				return {};
			}
		},
		groupDetails: {
			type: Object,
			default() {
				return {};
			}
		},
		groupAvaible: {
			type: Object,
			default() {
				return {};
			}
		},
	},
	mounted(){
		//console.log('groupKey',this.$store.getters['orm/group'](this.carGroup.groupKey));
		console.log("this.groupDetails",this.groupDetails);
	},
	methods: {
		iconTranslator: function(key, value) {
			switch (key) {
				case 'Personen':
				  	return '<span class="icn icn-person" title="'+key+'">' + value + '</span>';
				    break;
				case 'Koffer':
				  	return '<span class="icn icn-car_luggage" title="'+key+'">' + value + '</span>';
				    break;
				case 'Türen':
				    return '<span class="icn icn-car_doors" title="'+key+'">' + value + '</span>';
				    break;
				case 'Schaltung':
				    return '<span class="icn icn-car_gear" title="'+key+'">' + value + '</span>'; //value.substring(0, 1)
				    break;
				case 'Gewicht':
				    return '<span class="icn icn-car_weight" title="'+key+'">' + value + '</span>';
				    break;
				case 'Ladefläche (LxBxH)':
				    return '<span class="icn icn-car_volume" title="'+key+'">' + value + '</span>';
				    break;
				case 'Sonstiges':
				    return '<span class="icn icn-car_navi" title="'+key+'">' + value + '</span>';
				    break;
				case 'Klimaanlage':
				    return '<span class="icn car_klima" title="'+key+'">' + value + '</span>';
				    break;
				case 'CO2-Effizienzklasse':
				    return '<span class="icn co2" title="'+key+'">' + value + '</span>';
				    break;
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Generals/CarGroupCard.vue